import styled from 'styled-components';

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 8px;
  min-width: 100%;
`;

export const PlainFieldUsername = styled.div`
  flex-basis: 49%;
  margin-top: 26px;
  margin-right: 2px;
`;

export const PlainFieldPassword = styled.div``;

export const Row = styled.div`
  display: flex;
`;
